module.exports = {"blog":"https://blog.trello.com","twitter":"https://www.twitter.com/trello","facebook":"https://www.facebook.com/TrelloApp","instagram":"https://www.instagram.com/trelloapp/"}


//////////////////
// WEBPACK FOOTER
// ./resources/locales/locale-data/social/en.json
// module id = ./resources/locales/locale-data/social/en.json
// module chunks = 26 27 28